import type { Card, CardSummary } from "@/lib/api/client";

/**
 * The dashboard draws real `Card` objects from summaries; the summary carries
 * the money. One adapter, so the stack and the wall can't drift apart.
 */
export function summaryToCard(summary: CardSummary): Card {
  return {
    id: summary.card_id,
    issuer: summary.issuer,
    product_name: summary.product_name,
    network: null,
    last4: summary.last4,
    nickname: summary.nickname,
    theme: summary.theme,
    rewards_note: null,
    billing_day: null,
    due_day: null,
    credit_limit: summary.credit_limit,
    billing_day_pinned: false,
    due_day_pinned: false,
    credit_limit_pinned: false,
    status: "active",
    source: "manual",
    has_pdf_password: false,
    created_at: "",
    updated_at: "",
  };
}
